export default defineNuxtRouteMiddleware(to => {
  // Skip middleware during SSR
  if (!import.meta.client) return

  console.group(`🛡️ Admin Middleware (${to.path})`)
  const isAdmin = useAdmin()
  console.log('Is admin check:', isAdmin.value)

  if (!isAdmin.value) {
    console.log('⚠️ Non-admin access attempted, redirecting to login')
    console.groupEnd()
    return navigateTo('/signin')
  }
  console.groupEnd()
})
